import { useEffect, useState } from 'react';
import { PlayerEventData } from '../../types/DatatrackTypes';
import usePlayerEvent from '../usePlayerEvent/usePlayerEvent';
export default function usePlayerEventData() {
    const playerEvent = usePlayerEvent();
    const [eventData, setEventData] = useState();
    useEffect(() => {
        if (playerEvent === null || playerEvent === void 0 ? void 0 : playerEvent.data) {
            const data = playerEvent.data;
            const newEvent = new PlayerEventData(data.event, data.param);
            setEventData(newEvent);
        }
    }, [playerEvent]);
    return eventData;
}
//# sourceMappingURL=usePlayerEventData.js.map